import styles from "./EditContact.module.scss";

function EditContact() {
  return <div className={styles.maincontainer}>Edit Contact</div>;
}
export default EditContact;
